import { createFileRoute } from '@tanstack/react-router'
import PlusIcon from '~/components/icons/PlusIcon'
import { CategoriesPageLayout } from '~/components/routes/categories/categories-page-layout'
import { CategoriesPanel } from '~/components/routes/categories/CategoriesPanel'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'
import { CATEGORIES_TAB_PERMISSIONS } from '~/components/routes/categories/tabs'

export const Route = createFileRoute('/_authenticated/categories/categories')({
  staticData: {
    permission: CATEGORIES_TAB_PERMISSIONS.categories,
  },
  component: CategoriesTabPage,
})
withRoutePermissions(Route)

function CategoriesTabPage() {
  return (
    <CategoriesPageLayout
      activeTab="categories"
      actions={
        <AuthorizedButtonLink variant="contained" to="/categories/new" legacyRights={['ADMIN']}>
          <PlusIcon />
          Ajouter une catégorie
        </AuthorizedButtonLink>
      }
    >
      <CategoriesPanel />
    </CategoriesPageLayout>
  )
}
